<template>
    <div class="setting-wrap">
        {{ $router.path }}
        <h2>개인정보 변경</h2>
        <p>회원님의 정보를 안전하게 보호하기 위해 비밀번호를 다시 한번 입력해 주시기 바랍니다.</p>
        <p class="notice">※ 타인에게 노출되지 않도록 주의해 주세요.</p>
        <div class="user-list-wrap">
            <ul class="user-list">
                <li class="clearfix">
                    <label for="user-email">이메일 주소</label>
                    <input type="email" id="user-email" :value="account.email" readonly="readonly">
                </li>
                <li class="clearfix">
                    <label for="user-pw">비밀번호</label>
                    <input type="password" id="user-pw" v-model="pass">
                </li>
            </ul>
        </div>
        <p class="setting-btn"><button type="button" @click="valid_password">로그인</button></p>
        <!--<br /><br /><br /><br /><br /><br /><br /><br />-->
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { STATUS_CODE } from '@/lib/constants'
  export default {
    name: 'verify',
    data() {
      return {
        pass: ''
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
      async valid_password () {
        let post_data = {dr_id: this.account.pharm_id, pass: this.pass}
        // console.log('valid_password', post_data)
        let {data} = await this.axios.post('auth/dr/check_pass/pharm', post_data)
        if (data.status != STATUS_CODE.OK) return alert('비밀번호가 일치하지 않습니다')

        this.$router.push('/settings/pharminfo')
      }
    }
  }
</script>

<style scoped>
    .setting-wrap {
        width: 100%;
        padding: 30px;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        height: 520px;
    }

    .setting-wrap > h2 {
        margin-bottom: 15px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > p {
        color: #b2b2b2;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > .notice {
        color: #ff2a69;
        margin-bottom: 50px;
    }

    .user-list > li {
        height: 50px;
    }

    .user-list > li:first-child {
        margin-bottom: 10px;
    }

    .user-list > li label,
    .user-list > li input {
        float: left;
    }

    .user-list > li label {
        width: 150px;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .user-list > li input {
        padding: 0;
        box-sizing: border-box;
    }

    #user-email {
        border: none;
        letter-spacing: .5px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    #user-pw {
        width: 400px;
        height: 50px;
        border: 1px solid #d2d2d2;
    }

    .setting-btn {
        width: 120px;
        height: 50px;
        margin: 30px 0 0 150px;
        background-color: #746ce6;
    }

    .setting-btn button {
        color: #fff;
        width: 100%;
        height: 100%;
        border: none;
        text-align: center;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }
</style>